import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class IlokBaseComponent extends BaseComponent {
  public text: string = "Ilok";

  constructor(userService: UserService) {
    super(userService);
  }
}
